import {ApckPortletTable} from "../portlet";

export const ApckPortletVulnHosts = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "vulnhostsportlet"
        },
        title: {
            type: String,
            default: "Vulnerable Hosts"
        },
        size: {
            type: String,
            default: "sm"
        },
        description: {
            type: String,
            default: "A table showing the top 5 most vulnerable hosts"
        },
        src: {
            type: String,
            default: "/vulnhosts"
        },
        limit: {
            type: Number,
            default: 20
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                if (this.$globalFlags.spa) {
                    return this.$router.push({
                        name: 'vulnerabilities.view',
                        params: {
                            vulnerability_id: rec.get('_id')
                        }
                    });
                } else {
                    const params = new URLSearchParams({hosts: rec.get('host')});
                    const href = '/vulnerabilities?' + params.toString();
                    window.open(href, '_blank').focus();
                }
            },
        },
        cols: {
            type: Array,
            default: () => [
                {heading: "Host", data: "host"},
                {heading: "Unresolved", ctype: "vulncolumnnew", data: "vulns", canSearch: false, width: 170, right: true},
            ]
        },
    },
});
